import React from 'react';
import PropTypes from 'prop-types';
import 'Components/Cards/BlogPostsCard/BlogCardLabel.scss';

const BlogCardLabel = ({ category }) =>
  <div className={`blog-card-label-container-${category.toLowerCase()}`}>
    <div className="d-flex">
      <div className="label-slash" />
      <div className="blog-card-label">
        {category}
      </div>
    </div>
    <div className="label-triangle" />
  </div>;

BlogCardLabel.propTypes = {
  category: PropTypes.string,
};

BlogCardLabel.defaultProps = {
  category: 'games',
};

export default BlogCardLabel;
